import {Component, OnInit} from '@angular/core';
import {ActivatedRoute,Route} from '@angular/router';
import {Task} from '../../task';
import {LabService} from '../../lab-service.service';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.css']
})
export class TaskComponent implements OnInit {
  public  curTask:Task;
  constructor(public activatedRoute:ActivatedRoute,public labService:LabService) {
  }
  getTask(): void {
    this.activatedRoute.params.subscribe(data=>{
      console.log("Task id"+data.id);
      this.curTask = this.labService.curLab.tasks[data.id-1];
      console.log("cur Task:"+this.curTask.id);
    });

    // this.router.routeState.parent(this.activatedRoute).params.subscribe(params => {
    //   this.getDetailsById(params['id']);
    // })
    // console.log("id:"+id);
    // this.curLab = this.labService.getLab(id);
    // .subscribe(hero => this.hero = hero);
  }
  ngOnInit() {
    this.getTask();
  }

}


